import { useState, useMemo } from 'react';
import { getEffectiveStatus, isOverdue } from './invoicesConstants';

// Owns multi-select state for the invoices table + derived bulk-action eligibility.
export const useInvoiceSelection = ({ invoices, filteredInvoices }) => {
  const [selectedIds, setSelectedIds] = useState(new Set());

  const toggleSelectAll = () => {
    if (selectedIds.size === filteredInvoices.length) {
      setSelectedIds(new Set());
    } else {
      setSelectedIds(new Set(filteredInvoices.map(inv => inv.id)));
    }
  };

  const toggleSelect = (id) => {
    const newSelected = new Set(selectedIds);
    if (newSelected.has(id)) newSelected.delete(id);
    else newSelected.add(id);
    setSelectedIds(newSelected);
  };

  const clearSelection = () => setSelectedIds(new Set());

  const selectedInvoices = useMemo(
    () => invoices.filter(inv => selectedIds.has(inv.id)),
    [invoices, selectedIds]
  );

  const selectedInvoicesTotal = useMemo(
    () => selectedInvoices.reduce((sum, inv) => sum + (inv.amount || 0), 0),
    [selectedInvoices]
  );

  const canBulkCancel = selectedInvoices.some(inv => !['paid', 'cancelled', 'void', 'processing_payment', 'payment_processing'].includes(inv.status));
  const canBulkVoid = selectedInvoices.some(inv => !['cancelled', 'void'].includes(inv.status));
  const canBulkPay = selectedInvoices.some(inv => !['paid', 'cancelled', 'void'].includes(inv.status));
  const canBulkRemind = selectedInvoices.some(inv => ['ready_for_payment', 'amended_ready_for_payment', 'overdue'].includes(getEffectiveStatus(inv)) || isOverdue(inv));

  return {
    selectedIds,
    toggleSelect,
    toggleSelectAll,
    clearSelection,
    selectedInvoices,
    selectedInvoicesTotal,
    canBulkCancel,
    canBulkVoid,
    canBulkPay,
    canBulkRemind,
  };
};
